import './App.css';
import WebRoutes from './pages/Webroutes';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { messaging, onMessage } from './firebase';

function App() {
  useEffect(() => {
    // Listen for foreground messages
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);

      if (Notification.permission === 'granted') {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: '/logo.png',
        });
      }
    });

    return () => unsubscribe(); // cleanup
  }, []);
   useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        console.log('Registered service workers:', regs);
      });
    }
  }, []);

  return (
    <>
      <WebRoutes />
      <ToastContainer />
    </>
  );
}

export default App;
